import type { SelectFieldOption } from '../SingleSelectField/types';

// Check compatibility of previous values on options change
export const getNewSelectValuesOnOptionsChange = <O extends SelectFieldOption>({
  options,
  value,
}: {
  options: O[];
  value: (string | number)[];
}) => {
  const allOptionsValues = options.map((option) => option.value);
  const newValues = [];
  allOptionsValues.forEach((optionValue) => {
    if (!value.includes(optionValue as string | number)) {
      return;
    }
    newValues.push(optionValue);
  });

  return newValues;
};
